const backendGr = {
  auth_not_authenticated: 'Παρακαλούμε συνδεθείτε για να συνεχίσετε.',
  auth_permission_denied_add_org: 'Δεν έχετε δικαίωμα να προσθέσετε οργανισμό.',
  payload_missing_required_fields: 'Λείπουν ορισμένες υποχρεωτικές πληροφορίες.',
  organisation_invalid_type: 'Ο τύπος του οργανισμού δεν είναι έγκυρος.',
  organisation_duplicate_owner_name: 'Υπάρχει ήδη οργανισμός με αυτό το όνομα.',
  organisation_create_failed: 'Δεν ήταν δυνατή η δημιουργία του οργανισμού.',
  organisation_set_claims_failed_owner: 'Δεν ήταν δυνατή η ενημέρωση των δικαιωμάτων του ιδιοκτήτη.',
  organisation_set_claims_failed_user: 'Δεν ήταν δυνατή η ενημέρωση των δικαιωμάτων του χρήστη.',
  organisation_add_failed: 'Δεν ήταν δυνατή η προσθήκη του οργανισμού.',
  organisation_not_found: 'Δεν βρέθηκε ο συγκεκριμένος οργανισμός.',
  organisation_missing_fields: 'Τα στοιχεία του οργανισμού είναι ελλιπή.',
  onboarding_not_new_user: 'Αυτός ο λογαριασμός έχει ήδη ολοκληρώσει την ένταξη.',
  onboarding_unknown_error: 'Παρουσιάστηκε σφάλμα κατά την ολοκλήρωση της ένταξης.',
  email_invalid_argument: 'Εισαγάγετε ένα έγκυρο email.',
  email_already_verified: 'Αυτό το email έχει ήδη επιβεβαιωθεί.',
  email_no_data: 'Δεν ήταν δυνατή η προετοιμασία του email επιβεβαίωσης.',
  email_sending_failed: 'Δεν ήταν δυνατή η αποστολή του email. Δοκιμάστε αργότερα.',
  email_verification_failed: 'Δεν ήταν δυνατή η αποστολή νέου email επιβεβαίωσης.',
  promoter_not_found: 'Δεν βρέθηκε ο συγκεκριμένος promoter.',
  promoter_missing_claims: 'Το προφίλ του promoter είναι ελλιπές.',
  password_strength_failed: 'Επιλέξτε ισχυρότερο κωδικό που να καλύπτει όλες τις προϋποθέσεις.',
  invitation_invalid_token: 'Ο σύνδεσμος πρόσκλησης είναι άκυρος ή έχει λήξει. Ανοίξτε το πιο πρόσφατο email πρόσκλησης.',
  invitation_not_found: 'Δεν βρέθηκε η συγκεκριμένη πρόσκληση.',
  invitation_not_pending: 'Αυτή η πρόσκληση δεν εκκρεμεί πλέον.',
  invitation_missing_id: 'Λείπει η αναφορά της πρόσκλησης.',
  invitation_public_cancel_denied: 'Οι δημόσιες προσκλήσεις δεν μπορούν να ακυρωθούν.',
  invitation_not_inviter: 'Μόνο ο αποστολέας μπορεί να διαχειριστεί αυτήν την πρόσκληση.',
  invitation_not_inviter_or_delegate: 'Μόνο ο αποστολέας ή ο εκπρόσωπός του μπορεί να διαχειριστεί αυτήν την πρόσκληση.',
  invitation_promoter_not_public: 'Αυτός ο promoter δεν δέχεται δημόσιες προσκλήσεις.',
  invitation_invalid_email_format: 'Εισαγάγετε έγκυρο email και κωδικό πρόσβασης.',
  invitation_invalid_role_division: 'Ο επιλεγμένος ρόλος ή τμήμα δεν επιτρέπεται.',
  invitation_already_accepted: 'Αυτό το άτομο έχει ήδη αποδεχτεί πρόσκληση.',
  invitation_email_in_use: 'Αυτό το email χρησιμοποιείται ήδη.',
  invitation_create_failed: 'Δεν ήταν δυνατή η δημιουργία της πρόσκλησης.',
  invitation_create_user_failed: 'Δεν ήταν δυνατή η δημιουργία του λογαριασμού χρήστη.',
  invitation_create_user_ref_failed: 'Δεν ήταν δυνατή η σύνδεση του λογαριασμού χρήστη.',
  invitation_inviter_data_failed: 'Δεν ήταν δυνατή η φόρτωση των στοιχείων του αποστολέα.',
  invitation_inviter_claims_failed: 'Δεν ήταν δυνατή η φόρτωση των δικαιωμάτων του αποστολέα.',
  invitation_custom_claims_too_large: 'Τα δικαιώματα της πρόσκλησης είναι υπερβολικά.',
  invitation_invite_permission_denied: 'Δεν έχετε δικαίωμα να προσκαλέσετε κάποιον.',
  invitation_fetch_failed: 'Δεν ήταν δυνατή η φόρτωση των προσκλήσεων.',
  invitation_user_missing_email: 'Ο λογαριασμός σας χρειάζεται διεύθυνση email.',
  invitation_owner_missing: 'Δεν βρέθηκε ο ιδιοκτήτης του promoter.',
  invitation_role_not_authorized: 'Αυτός ο ρόλος δεν έχει δικαίωμα για προσκλήσεις.',
  invitation_role_not_found: 'Δεν βρέθηκε ο συγκεκριμένος ρόλος.',
  invitation_pending_exists: 'Υπάρχει ήδη πρόσκληση σε εξέλιξη για αυτό το άτομο.',
  invitation_cancel_unknown: 'Δεν ήταν δυνατή η ακύρωση της πρόσκλησης.',
  invitation_reject_unknown: 'Δεν ήταν δυνατή η απόρριψη της πρόσκλησης.',
  invitation_request_unknown: 'Δεν ήταν δυνατή η αποστολή του αιτήματος πρόσκλησης.',
  verify_email_unknown: 'Δεν ήταν δυνατή η επιβεβαίωση του email.',
  superuser_unauthorized: 'Μόνο οι υπερχρήστες μπορούν να εκτελέσουν αυτήν την ενέργεια.',
  superuser_invitations_unknown: 'Δεν ήταν δυνατή η φόρτωση της λίστας προσκλήσεων.',
  superuser_users_unknown: 'Δεν ήταν δυνατή η φόρτωση της λίστας χρηστών.',
  superuser_organisations_unknown: 'Δεν ήταν δυνατή η φόρτωση της λίστας οργανισμών.',
  signup_requires_auth: 'Παρακαλούμε συνδεθείτε για να συνεχίσετε.',
  signup_unknown_error: 'Παρουσιάστηκε σφάλμα κατά τη δημιουργία του λογαριασμού.',
  signup_update_password_failed: 'Δεν ήταν δυνατή η ενημέρωση του κωδικού πρόσβασης.',
  provider_already_exists: 'Αυτός ο πάροχος υπάρχει ήδη.',
  custom_claims_set_failed: 'Δεν ήταν δυνατή η ενημέρωση των δικαιωμάτων του λογαριασμού.',
} as const;

export default backendGr;
